class AnimatedLines {
  constructor() {
    this.refs = {
      line: '.js-animated-line',
    };

    this.dom = {
      $lines: document.querySelectorAll(this.refs.line),
    };

    this.state = {
    };

    this.mount();
  }


  mount() {
    const { dom } = this;
    
    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, {
      threshold: 0.1, // Trigger when 10% of element is visible
      rootMargin: '-10% 0%'
    });

    // Observe each line element
    dom.$lines.forEach(line => {
      observer.observe(line);
    });
  }
}

new AnimatedLines();
